import React, { useState } from "react";
import {
  Box,
  FormControl,
  TextField,
  useMediaQuery,
  useTheme,
  Collapse,
} from "@mui/material";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Question from "../../components/Question";
import ContinueButton from "../../components/ContinueButton";
import MoveButton from "../../components/MoveButton";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";
import {
  continueButtonSx,
  inputLabelSx,
  textAreaSx,
} from "../../lib/uiformatting";
import { setMissedDoses as updateMissedDoses } from "../../redux/userSlice";

export default function MissedDoses() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const user = useSelector((state) => state.user);

  const [missed, setMissed] = useState(user.missedDoses?.has || "");
  const [pillsLeft, setPillsLeft] = useState(
    user.missedDoses?.pillsLeft == null ? "" : String(user.missedDoses.pillsLeft)
  );
  const [error, setError] = useState(false);

  const options = {
    Yes: "y",
    No: "n",
  };

  const handleYesChange = (value) => {
    setMissed(value);

    if (value === "n") {
      setPillsLeft("");
      setError(false);
    }
  };

  const handlePillsChange = (e) => {
    const value = e.target.value;

    if (!/^\d*$/.test(value)) return;

    setPillsLeft(value);
    setError(value === "");
  };

  const handleNext = () => {
    dispatch(
      updateMissedDoses({
        has: missed,
        pillsLeft: missed === "y" ? Number(pillsLeft) : 0,
      })
    );

    setPageAndDeferNavigate(dispatch, "/side-effects-checklist", navigate);
  };

  const handleBack = () => {
    setPageAndDeferNavigate(dispatch, "/medical-history-updates", navigate);
  };

  const pillsLeftEmpty = pillsLeft.trim() === "";

  return (
    <Question
      onBack={handleBack}
      title="Have you missed any pills/doses?"
      subtitle="Select one"
      input={
        <Box display="flex" flexDirection="column" alignItems="center" width="100%">
          {/* YES / NO BUTTONS */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              width: "100%",
              maxWidth: "350px",
              gap: "1rem",
              mt: 2,
            }}
          >
            {Object.keys(options).map((label) => (
              <MoveButton
                key={options[label]}
                title={label}
                selected={missed === options[label]}
                onClick={() => handleYesChange(options[label])}
              />
            ))}
          </Box>

          {/* CONDITIONAL INPUT */}
          <Collapse
            in={missed === "y"}
            mountOnEnter
            unmountOnExit
            sx={{
              width: "100%",
              maxWidth: isDesktop ? "600px" : "100%",
              mt: "3rem",
            }}
          >
            <FormControl required sx={{ width: "100%" }}>
              <TextField
                label="How many pills do you have left?"
                variant="outlined"
                color="secondary"
                type="number"
                inputProps={{ min: 0, step: 1 }}
                autoComplete="off"
                value={pillsLeft}
                onChange={handlePillsChange}
                error={error}
                helperText={error ? "Please enter remaining pills." : ""}
                sx={{
                  ...textAreaSx,
                  "& .MuiInputLabel-root": {
                    backgroundColor: theme.palette.background.paper,
                    padding: "0 32px",
                  },
                }}
                InputLabelProps={{
                  sx: inputLabelSx,
                }}
              />
            </FormControl>
          </Collapse>
        </Box>
      }
      footer={
        <Box sx={continueButtonSx}>
          <ContinueButton
            title="Continue"
            onClick={handleNext}
            disabled={missed === "" || (missed === "y" && pillsLeftEmpty)}
            selected={missed === "n" || (missed === "y" && !pillsLeftEmpty)}
          />
        </Box>
      }
    />
  );
}
